<template>
	<div data-tour-scope="shippings-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.listShipping') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>


						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="3" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="3">
									<v-menu v-model="dataordine" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
										<template v-slot:activator="{ on }">
											<v-text-field :value="computedDatejs" v-on="on" dense clearable @click:clear="cleardate" label="Data ordine" outlined hide-details> </v-text-field>
										</template>
										<v-date-picker v-model="settings.filters.created_at" @change="dataordine = false" range></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.platform" :items="platform" multiple dense label="Platform" hide-details outlined></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.payments" :items="payments" multiple dense label="Payment" hide-details outlined></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.status" :items="status" multiple dense label="Status" hide-details outlined></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.shipped"
										:items="[
											{ text: 'Si', value: true },
											{ text: 'No', value: false },
										]"
										multiple
										dense
										label="Spedito"
										outlined
										hide-details
									></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.couriers" :items="couriers" multiple dense label="Corriere" hide-details outlined></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-if="hasOrderTags"
										v-model="settings.filters.tags"
										:items="orderTags"
										item-text="label"
										item-value="_id"
										:menu-props="{ closeOnContentClick: true, maxHeight: '400' }"
										label="Tags"
										multiple
										clearable
										dense
										prepend-inner-icon="mdi-tag"
										outlined
										hide-details
									>
										<template v-slot:item="{ item }">
											<v-icon class="mr-2" :color="item.color">mdi-tag</v-icon>
											{{ item.label }}
										</template>
										<template v-slot:selection="{ item }">
											<v-chip small class="mr-1" :style="tagChipStyle(item)">{{ item.label }}</v-chip>
										</template>
									</v-select>
									<v-select
										v-else
										v-model="settings.filters.color"
										:items="selectColor"
										:menu-props="{ closeOnContentClick: true, maxHeight: '400' }"
										label="Tags"
										multiple
										clearable
										dense
										prepend-inner-icon="mdi-tag"
										outlined
										hide-details
									></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getOrders"
							:options.sync="settings.options"
							must-sort
							:server-items-length="total"
							class="elevation-0 cellanowrap"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni ordine diventa una card; il "+" apre prodotti e indirizzo DENTRO la card -->
								<tbody v-if="mobileCards" class="shipping-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :fields="campiCard(item)">
												<template v-slot:title>
													<span>{{ item.OrderID }}</span>
													<span v-if="item.buyer" class="font-weight-regular"> - {{ ((item.buyer.name || '') + ' ' + (item.buyer.lastname || '')) | truncate(25, '...') }}</span>
												</template>
												<template v-slot:actions>
													<v-menu bottom right eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list dense>
															<v-list-item link data-tour="row-create" @click="creaSpedizione(item)">
																<v-list-item-title class="size9">Crea spedizione</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="trackingItem(item)">
																<v-list-item-title class="size9">Tracking ordine</v-list-item-title>
															</v-list-item>
															<v-list-item v-if="item.shippings[0]" link @click="tracking(item.shippings[0], item)">
																<v-list-item-title class="size9">Tracking spedizione</v-list-item-title>
															</v-list-item>
															<v-list-item v-if="item.shippings[0] && linklabel" link :href="linklabel + '&ship=' + item.shippings[0]._id">
																<v-list-item-title class="size9">Scarica etichetta (LDV)</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
													<v-menu
														:disabled="disabled"
														:absolute="absolute"
														:open-on-hover="openOnHover"
														:close-on-click="closeOnClick"
														:close-on-content-click="closeOnContentClick"
														:offset-x="offsetX"
														:offset-y="offsetY"
													>
														<template v-slot:activator="{ on }">
															<v-btn icon small elevation="0" :color="tagButtonColor(item)" :title="tagButtonTitle(item)" v-on="on" data-tour="tag">
																<v-icon>mdi-tag</v-icon>
															</v-btn>
														</template>
														<v-list dense data-tour="ship-tag-list" v-if="hasOrderTags">
															<v-list-item v-for="tag in orderTags" :key="tag._id">
																<v-chip small :style="tagChipStyle(tag)" @click="changeStatus(item, tag)">{{ tag.label }}</v-chip>
															</v-list-item>
															<v-list-item>
																<v-chip small outlined @click="changeStatus(item, null)">Nessun tag</v-chip>
															</v-list-item>
														</v-list>
														<v-list dense data-tour="ship-tag-list" v-else>
															<v-list-item v-for="color in selectColor" :key="color">
																<v-btn @click="changeStatus(item, color)" elevation="0" icon :color="color"><v-icon>mdi-tag</v-icon></v-btn>
															</v-list-item>
														</v-list>
													</v-menu>
													<v-btn small icon color="primary" data-tour="expand" :title="checkpresenza(item._id) ? 'Chiudi' : 'Mostra prodotti e indirizzo'" @click="extension(item._id)">
														<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center flex-wrap mb-1">
														<v-avatar size="32px" tile>
															<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
														</v-avatar>
														<v-avatar size="16px" tile class="ml-1" v-if="item.ShippingAddress && item.ShippingAddress.Country">
															<img :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress.Country" />
														</v-avatar>
														<img v-if="item.shippings[0]" :src="getImageCourier(item.shippings[0].Platform)" class="ml-3" style="height: 30px; max-width: 80px" />
														<v-spacer></v-spacer>
														<v-btn icon small elevation="0" @click="trackingItem(item)" title="Tracking ordine" data-tour="order-tracking">
															<v-icon small>mdi-truck-fast-outline</v-icon>
														</v-btn>
														<v-btn v-if="item.shippings[0] && linklabel" text plain small elevation="0" title="LDV" :href="linklabel + '&ship=' + item.shippings[0]._id" data-tour="label">
															<img :src="require('@/assets/images/corrieri/label.svg')" style="height: 24px" />
														</v-btn>
													</div>
													<div v-if="item.shippings[0] && item.shippings[0].tracking" class="d-flex align-center mb-1">
														<v-btn text plain small elevation="0" class="px-0" title="Tracking spedizione" @click="tracking(item.shippings[0], item)">
															<img :src="require('@/assets/images/corrieri/tracking4.svg')" style="height: 24px" />
														</v-btn>
														<a class="ml-1 text-truncate" @click="tracking(item.shippings[0], item)">{{ item.shippings[0].tracking }}</a>
													</div>
												</template>
												<ShippingDetail
													v-if="checkpresenza(item._id)"
													:item="item"
													:linklabel="linklabel || ''"
													@tracking="ship => tracking(ship, item)"
													@order-tracking="trackingItem(item)"
													@create="creaSpedizione(item)"
												/>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr>
											<td class="pl-2 pr-0" style="width: 40px">
												<v-menu bottom right eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
															<v-icon>mdi-dots-vertical</v-icon>
														</v-btn>
													</template>
													<v-list dense>
														<v-list-item link data-tour="row-create" @click="creaSpedizione(item)">
															<v-list-item-title class="size9">Crea spedizione</v-list-item-title>
														</v-list-item>
														<v-list-item link @click="trackingItem(item)">
															<v-list-item-title class="size9">Tracking ordine</v-list-item-title>
														</v-list-item>
														<v-list-item v-if="item.shippings[0]" link @click="tracking(item.shippings[0], item)">
															<v-list-item-title class="size9">Tracking spedizione</v-list-item-title>
														</v-list-item>
														<v-list-item v-if="item.shippings[0] && linklabel" link :href="linklabel + '&ship=' + item.shippings[0]._id">
															<v-list-item-title class="size9">Scarica etichetta (LDV)</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
											<td class="pl-0">
												<v-btn small icon @click="extension(item._id)" data-tour="expand">
													<v-icon v-if="!checkpresenza(item._id)">mdi-plus</v-icon>
													<v-icon v-else>mdi-minus</v-icon>
												</v-btn>
											</td>
											<td>{{ item.created_at | moment('DD/MM/YYYY HH:mm:ss') }}</td>
											<td>
												<span>{{ item.OrderID }}</span>
												<v-btn icon small elevation="0" class="ml-1" @click="trackingItem(item)" title="Tracking" data-tour="order-tracking">
													<v-icon small>mdi-truck-fast-outline</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
												</v-avatar>
												<v-avatar size="16px" tile style="margin-left: 5px" v-if="item.ShippingAddress.Country">
													<img :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress" />
												</v-avatar>
											</td>
											<td>{{ (item.buyer.name + ' ' + item.buyer.lastname) | truncate(25, '...') }}</td>

											<td>
												{{ item.OrderStatus }}
											</td>
											<td>
												<span v-if="item.StatusOrder">{{ item.StatusOrder.value }}</span>
											</td>

											<td>
												<template v-if="item.shippings[0]">
													<img :src="getImageCourier(item.shippings[0].Platform)" style="height: 30px; max-width: 80px" />
													<!--                          <img v-if="item.shippings[0].Platform === 'spedisciOnline'" :src="getImageCourier(item.shippings[0].courier)" style="height: 30px; max-height: " />-->
												</template>
											</td>

											<td data-tour="label">
												<template v-if="item.shippings[0]">
													<v-avatar size="32px" tile v-if="linklabel">
														<v-btn text plain small elevation="0" :href="linklabel + '&ship=' + item.shippings[0]._id">
															<img :src="require('@/assets/images/corrieri/label.svg')" />
														</v-btn>
													</v-avatar>
												</template>
											</td>
											<td data-tour="ship-status">
												<template v-if="item.shippings[0]">
													<span v-if="item.shippings[0].cron === false" class="green--text font-weight-bold">{{ item.shippings[0].status }}</span>
													<span class="blue--text font-weight-bold" v-else>{{ item.shippings[0].status }}</span>
												</template>
											</td>

											<td>
												<template v-if="item.shippings[0] && item.shippings[0].tracking">
													<v-avatar size="32px" tile>
														<v-btn text plain small elevation="0" @click="tracking(item.shippings[0], item)"><img :src="require('@/assets/images/corrieri/tracking4.svg')" /></v-btn>
													</v-avatar>
													{{ item.shippings[0].tracking }}
												</template>
											</td>

											<td>
												<template v-if="item.shippings[0] && item.shippings[0].updated_at">
													{{ item.shippings[0].updated_at | moment('DD/MM/YYYY HH:mm:ss') }}
												</template>
											</td>

											<td>
												<template v-if="item.shippings[0] && item.shippings[0].created_at">
													{{ item.shippings[0].created_at | moment('DD/MM/YYYY HH:mm:ss') }}
												</template>
											</td>
											<td>
												<v-menu
													:disabled="disabled"
													:absolute="absolute"
													:open-on-hover="openOnHover"
													:close-on-click="closeOnClick"
													:close-on-content-click="closeOnContentClick"
													:offset-x="offsetX"
													:offset-y="offsetY"
												>
													<template v-slot:activator="{ on }">
														<v-btn icon small elevation="0" :color="tagButtonColor(item)" :title="tagButtonTitle(item)" v-on="on" data-tour="tag">
															<v-icon>mdi-tag</v-icon>
														</v-btn>
													</template>
													<v-list dense data-tour="ship-tag-list" v-if="hasOrderTags">
														<v-list-item v-for="tag in orderTags" :key="tag._id">
															<v-chip small :style="tagChipStyle(tag)" @click="changeStatus(item, tag)">{{ tag.label }}</v-chip>
														</v-list-item>
														<v-list-item>
															<v-chip small outlined @click="changeStatus(item, null)">Nessun tag</v-chip>
														</v-list-item>
													</v-list>
													<v-list dense data-tour="ship-tag-list" v-else>
														<template v-for="color in selectColor">
															<v-list-item>
																<v-btn @click="changeStatus(item, color)" elevation="0" icon :color="color"><v-icon>mdi-tag</v-icon></v-btn>
															</v-list-item>
														</template>
													</v-list>
												</v-menu>
											</td>

											<td></td>

										</tr>
										<tr v-if="checkpresenza(item._id)" class="sh-expanded">
											<td :colspan="headers.length" class="py-3">
												<ShippingDetail
													:item="item"
													:linklabel="linklabel || ''"
													@tracking="ship => tracking(ship, item)"
													@order-tracking="trackingItem(item)"
													@create="creaSpedizione(item)"
												/>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';


import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ShippingDetail from '@/components/shippings/ShippingDetail.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createShippingsListTourSteps, stopShippingsListTour } from './shippings-list-tour';
import { openWithReturn } from '@/components/core/pageReturn';
import { listRouteState } from '@/components/core/list/listRouteState';
import { isDarkColor } from '@/Helper';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Shippings',
	// pagina, righe, ordinamento, ricerca e filtri nell'URL: refresh e ritorno dalle pagine ripartono da li'
	mixins: [
		listRouteState({
			filters: { status: 'array', platform: 'array', created_at: 'array', payments: 'array', shipped: 'booleanArray', couriers: 'array', color: 'array', tags: 'array' },
			perPageOptions: LIST_SIZE,
		}),
	],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createShippingsListTourSteps(), { onStop: stopShippingsListTour }),
		};
	},
	data() {
		return {
			menu: false,
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					preparation_date: [],
					payments: [],
					agents: [],
					shipped: [],
					couriers: [],
					color: [],
					// tag ordine personalizzati (Profile.order_tags); `color` resta per i profili senza
					tags: [],
					// va inizializzato qui: se lo si imposta dentro getDataFromApi() il deep-watcher
					// su `settings` scatta e rilancia una seconda richiesta identica
					enableAgents: false,
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			linklabel: '',
			listSize: LIST_SIZE,
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: '', value: '', sortable: false },
				{ text: 'Date', value: 'created_at' },
				{ text: 'Order Id', value: 'OrderID' },
				{ text: 'Platform', value: 'Platform' },
				{ text: 'Nome e Cognome', value: 'buyer.name' },
				{ text: 'Status Ex', value: 'OrderStatus' },
				{ text: 'Status', value: 'Status' },
				{ text: 'Corriere', value: 'carrier', sortable: false },
				{ text: 'LDV', value: '', sortable: false },
				{ text: 'Stato', value: '', sortable: false },
				{ text: 'Tracking', value: '', sortable: false },
				{ text: 'Ultimo Agg.', value: '', sortable: false },
				{ text: 'Data Creazione', value: '', sortable: false },
				{ text: '', value: '', sortable: false },
				{ text: '', value: '', sortable: false },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			dataordine: '',
			datapreparazione: '',
			platform: [],
			status: [],
			payments: [],
			agents: [],
			couriers: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,
			page: 1,
			isMobile: false,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			operation: '',
			packagings: [],
			selectColor: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
		};
	},

	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},

	created() {},
	async mounted() {
		this.setDialog(false);
		this.setExistFilter(true);
		this.linkdownload = `${this.getUrl}orders/download`;
		this.linklabel = `${this.getUrl}nocors/shippings/label?token=${this.getToken}`;

		// la lista non dipende dalle chiamate di setup qui sotto: parte subito, in parallelo
		// (stato letto dall'URL in data())
		this.listLoad();

		let promises = [];
		promises.push(this.fetchSetting());
		promises.push(
			this.fetchServiceactive(['fattureInCloud', 'ebay', 'magento', 'shopify', 'mws', 'aliexpress', 'prestashop', 'woocommerce', 'ups', 'bartolini', 'dhl', 'spedisciOnline', 'gls', 'fedex']),
		);
		const result = await Promise.all(promises);
		const status = result[1];

		let magento = status.find(el => el.service === 'magento' && el.active === true);
		if (magento) {
			this.magento = magento.active;
			this.platform.push('Magento');
		}
		let shopify = status.find(el => el.service === 'shopify' && el.active === true);
		if (shopify) {
			this.shopify = shopify.active;
			this.platform.push('Shopify');
		}

		let aliexpress = status.find(el => el.service === 'aliexpress' && el.active === true);
		if (aliexpress) {
			this.aliexpress = aliexpress.active;
			this.platform.push('Aliexpress');
		}

		let prestashop = status.find(el => el.service === 'prestashop' && el.active === true);
		if (prestashop) {
			this.prestashop = prestashop.active;
			this.platform.push('Prestashop');
		}

		let woocommerce = status.find(el => el.service === 'woocommerce' && el.active === true);
		if (woocommerce) {
			this.woocommerce = woocommerce.active;
			this.platform.push('Woocommerce');
		}

		let fattureincloud = status.find(el => el.service === 'fattureInCloud' && el.active === true);
		if (fattureincloud) {
			this.fattureincloud = fattureincloud.active;
		}
		let mws = status.find(el => el.service === 'mws' && el.active === true);
		if (mws) {
			this.platform.push('Amazon');
		}

		let ebay = status.find(el => el.service === 'ebay' && el.active === true);
		if (ebay) {
			this.platform.push('Ebay');
		}

		let ups = status.find(el => el.service === 'ups' && el.active === true);
		if (ups) {
			this.couriers.push('ups');
		}

		let bartolini = status.find(el => el.service === 'bartolini' && el.active === true);
		if (bartolini) {
			this.couriers.push('bartolini');
		}

		let dhl = status.find(el => el.service === 'dhl' && el.active === true);
		if (dhl) {
			this.couriers.push('dhl');
		}

		let spedisciOnline = status.find(el => el.service === 'spedisciOnline' && el.active === true);
		if (spedisciOnline) {
			this.couriers.push('spedisciOnline');
		}

		let gls = status.find(el => el.service === 'gls' && el.active === true);
		if (gls) {
			this.couriers.push('gls');
		}

		let fedex = status.find(el => el.service === 'fedex' && el.active === true);
		if (fedex) {
			this.couriers.push('fedex');
		}

		this.platform.push('Store');

		this.fetchStatusOrder().then(result => {
			//console.log(result)
			_.forEach(result.data, el => {
				var textStatus = _.find(el.trans, { lang: this.getLanguage });

				this.status.push({ text: textStatus.value, value: el._id });
			});
		});

		this.fetchPaymentMethod().then(result => {
			_.forEach(result.data, el => {
				this.payments.push({ text: el.value, value: el._id });
			});
		});

		this.fetchAgentMethod().then(result => {
			_.forEach(result.data, el => {
				this.agents.push({ text: el.info.name + ' ' + el.info.lastname, value: el._id });
			});
		});
		this.fetchPackagings().then(result => {
			_.forEach(result.data, el => {
				this.packagings.push({ text: el.name, value: el });
			});
			//console.log(this.packagings)
		});

		this.$root.$on('updateOrdersList', () => {
			this.getDataFromApi();
		});
	},
	watch: {
		selectedchecbox() {
			if (this.selectedchecbox.length === 1) {
				let el = this.selectedchecbox[0];
				let item = _.find(this.getOrders, i => {
					return i._id === el;
				});
				if (item) {
					if (item.Invoice && item.Invoice.Number) {
						if (item.Invoice.Name === 'Ricevuta') {
							this.TypeInvoice = 'Ricevuta';
						}
						if (item.Invoice.Name === 'Fattura') {
							this.TypeInvoice = 'Fattura';
						}
						this.InvoiceItem = true;
					} else {
						this.InvoiceItem = false;
					}

					if (item.Status === 'In Preparazione') {
						this.checkInPreparazione = false;
						this.checkRollbackInPreparazione = true;
					}
				}
			} else {
				this.checkInPreparazione = true;

				_.forEach(this.selectedchecbox, ord => {
					let item = _.find(this.getOrders, i => {
						return i._id === ord;
					});
					if (item) {
						if (item.Status === 'In Preparazione') {
							this.checkInPreparazione = false;
							this.checkRollbackInPreparazione = true;
						}
					}
				});
			}
		},
	},
	components: {
		ShippingDetail,
		TourOverlay,
		KeyValueCard,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// tag ordine configurati in Impostazioni > Ordini (come nella lista Ordini). Se il profilo
		// non ne ha, filtro e tag della riga restano quelli storici basati sui colori fissi.
		orderTags() {
			return _.orderBy(this.getSetting?.order_tags || [], ['order'], ['asc']);
		},
		hasOrderTags() {
			return this.orderTags.length > 0;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getOrders: 'shippings/getOrders',
			getSetting: 'settings/getSetting',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'shippings/getIndex',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'shippings/getSortBy',
			getSortDesc: 'shippings/getSortDesc',
			getLanguage: 'profile/getLanguage',
		}),
		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		filteredItems() {
			let filters = this.getOrders;

			filters = filters.filter(d => {
				//console.log("fine",moment(this.parseDate[1]+" 23:59:59").utc().format());
				if (this.parseDate.length === 1) {
					return (
						d.created_at >
						moment(this.parseDate[0] + ' 00:00:00')
							.utc()
							.format()
					);
				}
				if (this.parseDate.length === 2) {
					return (
						d.created_at >
							moment(this.parseDate[0] + ' 00:00:00')
								.utc()
								.format() &&
						d.created_at <
							moment(this.parseDate[1] + ' 23:59:59')
								.utc()
								.format()
					);
				}
				return d;
			});

			filters = filters.filter(d => {
				if (this.choosePlaform.length > 0) {
					return this.choosePlaform.includes(d.Platform);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.chooseStatus.length > 0) {
					return this.chooseStatus.includes(d.Status);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.choosePayments.length > 0) {
					return this.choosePayments.includes(d.Checkout.PaymentMethods);
				}
				return d;
			});
			if (filters.length > 0) {
				let sum = filters.reduce((total, current) => total + current.Total, 0);

				this.Totale = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				let sum = filters.reduce((total, current) => total + current.Refund, 0);

				this.Refund = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				let total = 0;
				let refund = 0;
				filters.forEach(value => {
					if (value.Buy) {
						total += this.scorporoiva(value.Total, value.BuyVat) - value.Buy - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
					if (value.Refund) {
						refund += value.Total - value.Refund - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
				});
				this.Gain = parseFloat(total + refund, 2).toFixed(2);
			}
			return filters;
		},

		computedDatejs() {
			let arrayDate = [];
			if (this.settings.filters.created_at.length > 0) {
				this.settings.filters.created_at.forEach(value => {
					// console.log(value)
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
			//return this.parseDate ? moment(this.parseDate).format('DD/MM/YYYY') : ''
		},
		computedDatePrepjs() {
			let arrayDate = [];
			if (this.settings.filters.preparation_date.length > 0) {
				this.settings.filters.preparation_date.forEach(value => {
					// console.log(value)
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
	},

	methods: {
		// coppie chiave/valore della card da telefono (colonne in sola lettura della riga desktop)
		campiCard(item) {
			const ship = item.shippings && item.shippings[0];
			const data = v => (v ? this.$moment(v).format('DD/MM/YYYY HH:mm:ss') : '');
			return [
				{ label: 'Data', value: data(item.created_at) },
				{ label: 'Status Ex', value: item.OrderStatus },
				{ label: 'Status', value: item.StatusOrder ? item.StatusOrder.value : '', strong: true },
				{ label: 'Stato spedizione', value: ship ? ship.status : '', strong: true },
				{ label: 'Ultimo agg.', value: ship ? data(ship.updated_at) : '' },
				{ label: 'Data creazione', value: ship ? data(ship.created_at) : '' },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setOrders: 'shippings/setOrders',
			setOrder: 'shippings/setOrder',
			setTracking: 'shippings/setTracking',
			setIndex: 'shippings/setIndex',
			setOrderStoreList: 'orders/setOrders',
			setOrderStore: 'orders/setOrder',
			setOrderStoreIndex: 'orders/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchOrders: 'shippings/asyncFetchData',

			destroyData: 'shippings/destroyData',

			fetchSetting: 'settings/asyncFetchData',
			createSupplierOrders: 'orders/createSupplierOrders',
			getOrderDetail: 'orders/edit',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchPaymentMethod: 'paymentmethods/fetchLists',
			fetchAgentMethod: 'agents/fetchLists',
			fetchPackagings: 'packagings/getListings',
			fetchServiceactive: 'services/getServiceFetchActive',

			//'resetMessages' : 'settings/resetMessages'
		}),
		getImageCourier(img) {
			//:src='require("@/assets/images/corrieri/"+ship.courier+".svg")'
			if (!img) {
				return require(`@/assets/images/corrieri/tracking2.svg`);
			}

			try {
				return require(`@/assets/images/corrieri/${img}.svg`);
			} catch (e) {
				return require(`@/assets/images/corrieri/tracking2.svg`);
			}
		},
		changePackagingDelete(item) {
			let url = 'orders/updatepackaging';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, Packaging: {} }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					//   this.dialog = false;
					//   this.success = true;

					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					item.Packaging = {};
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		changePackaging(pack, item) {
			let url = 'orders/updatepackaging';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, Packaging: pack.value }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					//   this.dialog = false;
					//   this.success = true;

					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					item.Packaging = pack.value;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		tracking(spedizione) {
			// il tracking della spedizione si apre come pagina; Indietro torna qui
			if (spedizione && spedizione._id) this.$router.push(`/shippings/${spedizione._id}/tracking`);
		},
		trackingItem(item) {
			// il tracking dell'ordine si apre come pagina; Annulla/Salva tornano qui
			openWithReturn(this, { path: `/orders/${item._id}/tracking` }, { label: 'Torna alle spedizioni' });
		},
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.selectedchecbox = [];
			this.operation = '';
		},
		async creaOrdineFornitore() {
			this.dialogOrderSupplier = true;
		},
		async inviaOrdineFornitore() {
			this.dialogOrderSupplier = false;
			this.preload = true;
			let orders_id = this.selectedchecbox;
			let payload = { order_date: this.dateOrderSupplier, order_ids: orders_id };
			let response = await this.createSupplierOrders(payload);

			if (response.result === true && response.all_transformed) {
				await this.fetchOrders(this.settings);
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con  successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
			} else if (response.result === true && !response.all_transformed) {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con successo, ma alcuni prodotti non hanno un fornitore associato';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
			} else {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante invio in preparazione';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
			}
		},

		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormCreate';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		// chip del tag ordine: sfondo del tag, testo bianco su colore scuro e nero su chiaro
		tagChipStyle(tag) {
			return {
				backgroundColor: tag.color,
				color: isDarkColor(tag.color) ? '#FFFFFF' : '#000000',
			};
		},
		tagButtonColor(item) {
			if (this.hasOrderTags) return item.Tag && item.Tag.color ? item.Tag.color : 'grey';
			return item.Color || 'grey';
		},
		tagButtonTitle(item) {
			return this.hasOrderTags && item.Tag && item.Tag.label ? item.Tag.label : '';
		},
		/**
		 * Assegna il tag a un ordine (stessa logica della lista Ordini).
		 * `value` e' una stringa colore quando il profilo non ha tag configurati, l'oggetto tag di
		 * `Profile.order_tags` quando li ha, `null` per rimuoverlo.
		 */
		changeStatus(item, value) {
			let url = 'orders/updatestatus';
			let payload = item;
			const tag = this.hasOrderTags ? (value ? { _id: value._id, label: value.label, color: value.color } : null) : undefined;
			const color = this.hasOrderTags ? (value ? value.color : null) : value;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			const body = { item: payload, color: color };
			if (this.hasOrderTags) {
				body.tag = tag;
			}
			axios
				.post(`${this.getUrl}${url}`, body, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					if (this.hasOrderTags) {
						// `Tag` puo' non esistere sull'ordine (mai taggato): serve $set per la reattivita'
						this.$set(this.getOrders[this.editIndex], 'Tag', tag);
						this.$set(this.getOrders[this.editIndex], 'Color', color);
					} else {
						Object.assign(this.getOrders[this.editIndex], { Color: color });
					}
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		/*toggleAll () {


                if (this.selected.length) this.selected = []
                else this.selected = this.getOrders.slice()


            },*/
		/*changeSort (column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
            },*/
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},
		copy(field) {
			let input = document.createElement('input');

			input.setAttribute('value', field);
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
		},
		scorporoiva(totale, iva) {
			let sc = 0;
			if (!iva || iva === 0) {
				iva = 22;
				iva = iva / 100;
				iva += 1;

				sc = parseFloat(totale / iva).toFixed(2);
			} else {
				sc = totale;
				//sc=100000
			}
			return sc;
		},

		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		cleardate() {
			this.parseDate = [];
			this.settings.filters.created_at = [];
			this.settings.filters.preparation_date = [];
		},
		async editItem() {
			this.componentKey += 1;
			let el = this.selectedchecbox[0];
			let item = _.find(this.getOrders, i => {
				return i._id === el;
			});

			this.setClearError({});

			this.operation = 'FormEdit';
			this.setIndex(this.getOrders.indexOf(item));
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		/*checkInvoice(){
                console.log("ssssssssssssssssssssdentro")
                let el = this.selectedchecbox[0]
                let item = _.find(this.getOrders,i => {
                    return i._id==el
                })
                if(item){
                    if(item.Invoice.Number){
                        console.log("true")
                        return true
                    }else{
                        console.log("false")
                        return false
                    }
                }

            },*/
		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;

				let items = this.fetchOrders(this.settings);
				items.then(result => {
					// quando la richiesta fallisce lo store risolve con undefined: senza guardia
					// qui si rompeva la then e il preload restava acceso all'infinito
					this.total = result ? result.total : this.total;
					this.setPreload(false);
					this.selectedchecbox = [];
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.componentKey += 1;

			this.setClearError({});

			this.operation = 'FormCreate';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		// dalla barra dei selezionati (checkbox) oppure dal dettaglio col "+" (ordine passato)
		creaSpedizione(ordine) {
			// la creazione della spedizione si apre come pagina; Annulla/Salva tornano qui
			if (ordine && ordine._id) this.$router.push({ path: '/shippings/new', query: { order: ordine._id } });
		},
		extension(item) {
			let prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				let indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}

			/*this.selected.push(item)

                    if (!this.getOrders[item].hide) {
                        this.getOrders[item].hide = true;
                    } else  {
                        this.getOrders[item].hide = false;
                    }*/
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		creaFattura() {
			this.componentKey += 1;
			let el = this.selectedchecbox[0];
			let item = _.find(this.getOrders, i => {
				return i._id === el;
			});
			/*let url = "fattureincloud/createFattura";
                var payload = item;*/
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			this.operation = 'FormCreateInvoice';
			this.setIndex(this.getOrders.indexOf(item));
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);

			//console.log(`${this.getUrl}${url}`);
			/*axios.post(`${this.getUrl}${url}`,payload, { 'headers': { 'Authorization': `Bearer ${this.getToken}`}})
                    .then( ({data}) => {
                        //   this.dialog = false;
                        //   this.success = true;
                        //  console.log(data.data);

                        this.preload = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color="success";
                        this.snackbar.text= "Operazione effettuata con  successo";

                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout=5000;
                        Object.assign(this.getOrders[this.editIndex], data.data);
                        this.InvoiceItem=true
                        this.TypeInvoice='Fattura'


                    })
                    .catch(err => {

                        if(err.response) {
                            let errors = err.response.data.error;
                            if (errors) {
                                console.log(errors);
                                if(_.isArray(errors)) {
                                    errors.forEach(value => {
                                        //console.log(value.msg);
                                        this.messages[value.param] = value.msg
                                    })
                                }else{
                                    err.message=errors
                                }

                            }
                            this.snackbar.color="error";
                            this.snackbar.text= err.message;
                            this.snackbar.snackbar = true;
                            this.snackbar.mode = 'multi-line';
                            this.snackbar.timeout=5000;
                            this.preload = false;
                            if(err.response.status===401){
                                this.setLogout();
                                this.$router.push('/login')
                            }
                        }
                    });*/
		},
		eliminaCorrispettivo() {
			let el = this.selectedchecbox[0];
			let item = _.find(this.getOrders, i => {
				return i._id === el;
			});

			let url = 'fattureincloud/eliminaCorrispettivi';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//  console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		eliminaFattura() {
			let el = this.selectedchecbox[0];
			let item = _.find(this.getOrders, i => {
				return i._id === el;
			});
			let url = 'fattureincloud/eliminaFattura';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		annullaOrdineFornitore() {
			let el = this.selectedchecbox[0];
			let item = _.find(this.getOrders, i => {
				return i._id === el;
			});
			let url = 'orders-suppliers/rollback';
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, { order_id: item.OrderID.toString() }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.getDataFromApi();
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		getImagePayment(img) {
			if (!img) {
				return require(`@/assets/images/Other.svg`);
			}

			try {
				return require(`@/assets/images/${img.value}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},
		getImageShip(item) {
			if (item.ShippedTime) {
				return require(`@/assets/images/box_ship.svg`);
			}
			if (item.CancelTime) {
				return require(`@/assets/images/box_cancel.svg`);
			}
			let delivery;
			item.Items.forEach(value => {
				delivery = value.Delivery_max;
			});

			if (delivery) {
				let fromDate = parseInt(new Date().getTime() / 1000);
				let toDate = parseInt(new Date(delivery).getTime() / 1000);
				let timeDiff = (toDate - fromDate) / 3600; // will give difference in hrs
				let box = '';

				if (timeDiff > 6) {
					return require(`@/assets/images/box.svg`);
				}
				if (timeDiff > 1 && timeDiff <= 6) {
					return require(`@/assets/images/box_warning.svg`);
				}
				if (timeDiff <= 1) {
					return require(`@/assets/images/box_late.svg`);
				}
				return require(box);
			} else {
				return require(`@/assets/images/box.svg`);
			}
		},

		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},

		deleteItem(item) {
			this.dialogconfirm = true;

			this.form = item;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			this.preload = true;
			let url = 'auth/delete';
			this.messages = [];

			axios
				.delete(`${this.getUrl}${url}/${this.form._id}`, { headers: { Authorization: `Bearer ${this.getToken}` } })

				.then(() => {
					const index = this.items.indexOf(this.form);
					this.items.splice(index, 1);
					this.deleteitem = '';
					this.snackbar.color = 'success';
					this.snackbar.text = 'Utente Eliminato con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					//confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
					//this.form.permission=pluck(res.data.permissions,id);
					this.preload = false;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							console.log(errors);
							errors.forEach(value => {
								console.log(value.msg);
								this.messages[value.param] = value.msg;
							});
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();
		//clearInterval(this.setinterval)

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.shipping-cards,
.shipping-cards tr {
	display: block;
	width: 100%;
}
.shipping-cards tr,
.shipping-cards tr:hover {
	background: transparent !important;
}
.shipping-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.shipping-cards tr:first-child td {
	padding-top: 12px !important;
}
.shipping-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.shipping-cards tr + tr td {
	padding-top: 8px !important;
}
/* riga espansa del desktop: il dettaglio prende tutta la larghezza, niente hover */
.sh-expanded,
.sh-expanded:hover {
	background: transparent !important;
}
</style>
